"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Commander Spellbook API
 * API for Commander Spellbook, the combo database engine for Magic: The Gathering
 *
 * The version of the OpenAPI document: 4.8.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfCardInDeck = instanceOfCardInDeck;
exports.CardInDeckFromJSON = CardInDeckFromJSON;
exports.CardInDeckFromJSONTyped = CardInDeckFromJSONTyped;
exports.CardInDeckToJSON = CardInDeckToJSON;
exports.CardInDeckToJSONTyped = CardInDeckToJSONTyped;
/**
 * Check if a given object implements the CardInDeck interface.
 */
function instanceOfCardInDeck(value) {
    if (!('card' in value) || value['card'] === undefined)
        return false;
    if (!('quantity' in value) || value['quantity'] === undefined)
        return false;
    return true;
}
function CardInDeckFromJSON(json) {
    return CardInDeckFromJSONTyped(json, false);
}
function CardInDeckFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'card': json['card'],
        'quantity': json['quantity'],
    };
}
function CardInDeckToJSON(json) {
    return CardInDeckToJSONTyped(json, false);
}
function CardInDeckToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'card': value['card'],
        'quantity': value['quantity'],
    };
}
//# sourceMappingURL=cardInDeck.js.map